import styled, { createGlobalStyle } from 'styled-components/macro'

const primaryColor = '#17171E'

const GlobalStyle = createGlobalStyle`
  *{
    box-sizing:border-box;  
    margin:0;
    padding:0;
    overflow-x:hidden;
  
    &::-webkit-scrollbar {
      display: none;
    }
  }

  html{
    scroll-behavior:smooth;
    background-color:${primaryColor}
  }
`

export const SectionTitle = styled.div`
  padding: 2.25rem 0;
  font-size: 2.25rem;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Lexend Exa', 'sans-serif';
  @media screen and (max-width: 768px) {
    font-size: 1.75rem;
    /* padding: 2.25rem inherit; */
  }
`
export const SectionSubTitle = styled.div`
  font-size: 2.5rem;
  margin-left: 1rem;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: 'Lexend Exa', 'sans-serif';
  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }
`
export const BtnsDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 1.1rem;
  font-family: 'Lexend Exa', 'sans-serif';
  @media screen and (max-width: 768px) {
    font-size: 0.75rem;
  }
`
export const ProjectLinkButton = styled.div`
  align-items: center;
  display: flex;
  border-radius: 5px;
  /* padding: 1rem; */
  justify-content: space-evenly;

  width: ${({ blogBtn }) => (blogBtn ? `8rem` : `12rem`)};
  height: ${({ blogBtn }) => (blogBtn ? `2.6rem` : `3rem`)};

  cursor: pointer;

  color: rgba(49, 54, 87, 1);

  &:hover {
    background-color: #a7b9c9;
    transition: ease-in 0.15s;
  }

  background: #c3d7e8ff;
  @media screen and (max-width: 768px) {
    width: 10rem;
  }
`

export const Icon = styled.img`
  width: ${({ blogBtn }) => (blogBtn ? `1.3rem` : `1.5rem`)};

  @media screen and (max-width: 768px) {
    width: 1rem;
  }
`

export default GlobalStyle
